import * as React from 'react';

export class Title extends React.PureComponent<{}, {}> {
    public render() {
        return <div><h2>{this.props.children}</h2></div>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/BasePage/Title.tsx